import {
  Component,
  ElementRef,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { NkMatchMediaService } from '../../services/app-services/match-media.service';
import { wait } from '../../shared/fun';
import { AppThemeStore } from '../../stores/app/theme.state';
import { NkNavigationService } from '../navigation/navigation.service';
import { ShortcutsItems } from './shortcuts.items';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { MatDividerModule } from '@angular/material/divider';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-shortcuts',
  templateUrl: './shortcuts.component.html',
  styleUrls: ['./shortcuts.component.scss'],
  standalone: true,
  imports:[
    MatIconModule,
    MatTooltipModule,
    RouterModule,
    MatMenuModule,
    MatFormFieldModule,
    MatDividerModule,
    MatListModule,
    CommonModule,
    MatInputModule 
  ]
})
export class NkShortcutsComponent implements OnInit, OnDestroy {
  shortcutItems: any[] = [];
  navigationItems!: any[];
  filteredNavigationItems!: any[];
  searching = false;
  mobileShortcutsPanelActive = false;
  toolbarColor!: string;
  matchMediaSubscription!: Subscription;
  onConfigChanged!: Subscription;

  @Input() navigation: any;

  @ViewChild('searchInput', { static: true }) searchInputField: any;
  @ViewChild('shortcuts', { static: true }) shortcutsEl!: ElementRef;

  // @Select(AppThemeStore.appThemeConfig)
private appThemeConfig$: Observable<any> = inject(Store).select(AppThemeStore.appThemeConfig);

  constructor(
    private renderer: Renderer2,
    private breakpointObserver: BreakpointObserver,
    private nkMatchMedia: NkMatchMediaService,
    private nkNavigationService: NkNavigationService,
    private store: Store
  ) {
  
    //  this.appThemeConfig$ = this.store.select(AppThemeStore.appThemeConfig);
  }

  ngOnInit() {
      this.onConfigChanged = this.appThemeConfig$.subscribe((newSettings) => {
      this.toolbarColor = newSettings.colorClasses.toolbar;
    });
    // Get the navigation items and flatten them
    this.filteredNavigationItems = this.navigationItems = this.nkNavigationService.getFlatNavigation(
      this.navigation
    );

    // const cookieExists = this.cookieService.check('NK2.shortcuts');
    const cookieExists = localStorage.getItem('NK2.shortcuts');

    if (cookieExists) {
      this.shortcutItems = JSON.parse(
        // this.cookieService.get('NK2.shortcuts')
        localStorage.getItem('NK2.shortcuts') || '[]'
      );
    } else {
      // User's shortcut items
      this.shortcutItems = ShortcutsItems;
    }

    this.matchMediaSubscription = this.nkMatchMedia.onMediaChange.subscribe(
      () => {
        if (this.breakpointObserver.isMatched(Breakpoints.Web)) {
          this.hideMobileShortcutsPanel();
        }
      }
    );
  }

  ngOnDestroy() {
    this.matchMediaSubscription?.unsubscribe();
    this.onConfigChanged?.unsubscribe();
  }

  search(value: any) {
    value = value.toLowerCase();
    this.searching = true;

    this.filteredNavigationItems = this.navigationItems.filter(
      (navigationItem) => {
        return navigationItem.title.toLowerCase().includes(value);
      }
    );
  }

  toggleShortcut(event: any, itemToToggle: any) {
    event.stopPropagation();

    for (let i = 0; i < this.shortcutItems.length; i++) {
      if (this.shortcutItems[i].id === itemToToggle.id) {
        this.shortcutItems.splice(i, 1);

        // Save to the cookies
        // this.cookieService.set(
        localStorage.setItem(
          'NK2.shortcuts',
          JSON.stringify(this.shortcutItems)
        );

        return;
      }
    }

    this.shortcutItems.push(itemToToggle);

    // Save to the cookies
    // this.cookieService.set(
    localStorage.setItem('NK2.shortcuts', JSON.stringify(this.shortcutItems));
  }

  isInShortcuts(navigationItem: any) {
    return this.shortcutItems.find((item) => {
      return item.id === navigationItem.id;
    });
  }

  async onMenuOpen() {
    await wait(10);
    this.searchInputField.nativeElement.focus();
  }

  showMobileShortcutsPanel() {
    this.mobileShortcutsPanelActive = true;
    this.renderer.addClass(this.shortcutsEl.nativeElement, 'show-mobile-panel');
  }

  hideMobileShortcutsPanel() {
    this.mobileShortcutsPanelActive = false;
    this.renderer.removeClass(
      this.shortcutsEl.nativeElement,
      'show-mobile-panel'
    );
  }
}
